/** @jsx jsx */
import { css } from '@emotion/core'

// Using exact colors and styling from old midsec
const primaryColor = '#243588';
const secondaryColor = '#3fae2a';
const fontFamily = 'proxima-nova, sans-serif';

export const eventListStyle = {
  // Main container - matches .event-list-for-client-container from old midsec
  container: css`
    padding: 0px;
    margin-bottom: 20px;
    font-family: ${fontFamily};
    
    @media (min-width: 576px) {
      padding: 0px 100px;
    }
  `,

  loading: css`
    text-align: center;
    padding: 40px 0;
    font-size: 18px;
    color: #666;
    font-family: ${fontFamily};
  `,

  error: css`
    text-align: center;
    padding: 40px 0;
    font-size: 18px;
    color: #d32f2f;
    background-color: #ffebee;
    border-radius: 4px;
    border: 1px solid #ffcdd2;
    font-family: ${fontFamily};
  `,

  noEvents: css`
    text-align: center;
    padding: 40px 0;
    font-size: 18px;
    color: #666;
    background-color: #f5f5f5;
    border-radius: 4px;
    font-family: ${fontFamily};
  `,

  // Primary event (first event) - matches .event-list-for-client
  primaryEvent: css`
    margin-bottom: 30px;
    
    .regbtn {
      margin-top: 10px;
    }
  `,

  // Event type styling - matches old midsec event-view
  eventType: css`
    text-align: center;
    color: #000;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-family: ${fontFamily};
  `,

  // Event title - using default styling from old midsec
  eventTitle: css`
    color: #000;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.2;
    font-family: ${fontFamily};
  `,

  // Event description - using default styling
  eventDescription: css`
    font-size: 16px;
    line-height: 1.6;
    color: #000;
    margin-bottom: 20px;
    font-family: ${fontFamily};
    
    p {
      margin-bottom: 15px;
    }
    
    ul, ol {
      margin-left: 20px;
      margin-bottom: 15px;
    }
  `,

  eventDetails: css`
    margin-bottom: 25px;
  `,

  // Event date, time, place - matches old midsec styling with secondary color for labels
  eventDate: css`
    font-size: 16px;
    margin-bottom: 8px;
    color: #000;
    font-family: ${fontFamily};
    
    b, strong {
      color: ${secondaryColor};
      font-weight: 700;
    }
  `,

  eventTime: css`
    font-size: 16px;
    margin-bottom: 8px;
    color: #000;
    font-family: ${fontFamily};
    
    b, strong {
      color: ${secondaryColor};
      font-weight: 700;
    }
  `,

  eventPlace: css`
    font-size: 16px;
    margin-bottom: 15px;
    color: #000;
    font-family: ${fontFamily};
    
    b, strong {
      color: ${secondaryColor};
      font-weight: 700;
    }
  `,

  registrationInfo: css`
    font-size: 16px;
    color: #000;
    margin-bottom: 20px;
    font-family: ${fontFamily};
  `,

  phoneLink: css`
    color: ${primaryColor};
    font-weight: 600;
    text-decoration: none;
    
    &:hover {
      color: ${secondaryColor};
      text-decoration: underline;
    }
  `,

  // Register button - matches Bootstrap btn-primary styling from old midsec
  registerButton: css`
    display: inline-block;
    background-color: ${primaryColor};
    color: white;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-decoration: none;
    border-radius: 0.25rem;
    border: 1px solid ${primaryColor};
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    font-family: ${fontFamily};
    
    &:hover {
      background-color: ${secondaryColor};
      border-color: ${secondaryColor};
      color: white;
      text-decoration: none;
    }
    
    &:focus {
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(36, 53, 136, 0.25);
    }
  `,

  separator: css`
    margin: 40px 0;
    border: none;
    border-top: 1px solid #dee2e6;
  `,

  // Secondary events - matches .event-list-for-client-second from old midsec
  secondaryEvent: css`
    margin: 15px 0px;
    
    .event-title {
      display: inline-block;
      vertical-align: middle;
    }
    
    .regbtn {
      margin-left: 0px;
      margin-top: 5px;
      padding: 0px 15px;
      
      @media (min-width: 576px) {
        margin-top: 0px;
        margin-left: 10px;
      }
    }
    
    @media (max-width: 575px) {
      display: block;
    }
    
    @media (min-width: 576px) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `,

  secondaryEventTitle: css`
    font-size: 18px;
    font-weight: 400;
    color: #000;
    flex: 1;
    font-family: ${fontFamily};
    display: inline-block;
    vertical-align: middle;
    
    @media (max-width: 575px) {
      display: block;
      margin-bottom: 5px;
    }
  `
};
